// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"sY-z","sponsoredTooltipWrapper":"tY-z","sponsoredTooltip":"uY-z","newCard":"vY-z"};